import React from "react";
import { Stack, ToggleSwitch, Typography } from "digiwash-components";
import { TouchableOpacity } from "react-native";
interface RadioRowType {
  title: string;
  onSelect: () => void;
  selected: boolean;
}

function ToggleSwitchRow(props: RadioRowType) {
  return (
    <TouchableOpacity
      onPress={() => {
        props.onSelect();
      }}
    >
      <Stack distribution="space-between">
        <Typography color="gray.light950" ff="mainMedium">
          {props.title}
        </Typography>
        <ToggleSwitch selected={props.selected} />
      </Stack>
    </TouchableOpacity>
  );
}

export default ToggleSwitchRow;
